export const SecurityOperationsQuestions = [
    {
        id: 'sec-ops-001',
        text: 'Which backup strategy best ensures system recovery within defined RPO and RTO requirements while providing protection against ransomware?',
        options: [
            'Daily incremental backups only',
            'Weekly full backups with offline storage',
            'Continuous real-time replication',
            'Monthly differential backups'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Weekly full backups with offline storage provide a comprehensive recovery point while ensuring backup isolation from ransomware attacks. This strategy balances recovery capabilities with protection against malware that might encrypt online backups. Incremental backups rely on previous backups for a full recovery. If ransomware corrupts older backups, restoring data becomes much more difficult, especially if backups are overwritten daily.'
    },
    {
        id: 'sec-ops-002',
        text: 'What tool should a Security Operations Center (SOC) implement to standardize their incident response procedures?',
        options: [
            'Security benchmarks',
            'Security baselines',
            'Incident playbooks',
            'Security frameworks'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Incident playbooks provide step-by-step procedures for handling specific types of security incidents.'
    },
    {
        id: 'sec-ops-003',
        text: 'Which tool would be most effective for conducting TCP stack fingerprinting during a security assessment?',
        options: [
            'Wireshark',
            'tcpdump',
            'Nmap',
            'hping'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: 'hping is specifically designed for TCP stack fingerprinting and advanced packet manipulation.'
    },
    {
        id: 'sec-ops-004',
        text: 'Which type of security monitoring solution can function without requiring software installation on endpoints?',
        options: [
            'Host-based IDS',
            'Agent-based monitoring',
            'Network-based monitoring',
            'Application monitoring'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.3,
        explanation: 'Network-based monitoring can observe and analyze traffic without requiring software installation on individual endpoints, making it an agentless solution.'
    },
    {
        id: 'sec-ops-005',
        text: 'Which IPS deployment mode is most appropriate for initial testing and evaluation?',
        options: [
            'Active mode',
            'Monitor mode',
            'Inline mode',
            'Block mode'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Monitor mode (also called passive or tap mode) allows the IPS to observe and alert on traffic without risking disruption to the network, making it ideal for initial deployment and testing.'
    },
    {
        id: 'sec-ops-006',
        text: 'In which IPS mode would you achieve the most effective prevention of malicious traffic?',
        options: [
            'Monitor mode',
            'Passive mode',
            'Spanning mode',
            'Inline mode'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Inline mode allows the IPS to actively block malicious traffic as it passes through the device, providing the most effective prevention capabilities.'
    },
    {
        id: 'sec-ops-007',
        text: 'At which stage of the incident response process does a security analyst examine roles and responsibilities?',
        options: [
            'Response',
            'Detection',
            'Preparation',
            'Recovery'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.3,
        explanation: 'The preparation phase of incident response includes defining roles and responsibilities before incidents occur.'
    },
    {
        id: 'sec-ops-008',
        text: 'When trying to apply an important update to a crucial system, the update doesn\'t complete its transfer. What type of access control is probably preventing this action?',
        options: [
            'Discretionary access control',
            'Mandatory access control',
            'Role-based access control',
            'Least privilege'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: 'The principle of least privilege might prevent the update if the account doesn\'t have sufficient permissions to modify system files.'
    },
    {
        id: 'sec-ops-009',
        text: 'What is the primary function of a SIEM system?',
        options: [
            'Asset discovery',
            'Log aggregation and correlation',
            'Vulnerability scanning',
            'Automated threat response'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'The fundamental purpose of a SIEM is to collect and correlate logs from multiple sources to identify security events and patterns.'
    },
    {
        id: 'sec-ops-010',
        text: 'Comparing SIEM and SOAR, which capability is unique to SOAR?',
        options: [
            'Alert generation',
            'Event correlation',
            'Automated response workflows',
            'Log collection'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.2,
        explanation: 'While both tools handle security events, SOAR distinguishes itself through automated response workflows and orchestration capabilities.'
    },
    {/*
        id: 'sec-ops-011',
        text: 'What should a SOC architect consider when implementing SOAR playbooks for high-risk scenarios?',
        options: [
            'Minimal human intervention',
            'Maximum possible automation',
            'Balance of automation and human oversight',
            'Fastest execution time'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: 'For high-risk scenarios, SOAR playbooks must carefully balance automated responses with appropriate human oversight to prevent automated actions from causing unintended consequences.'
    */},
    {
        id: 'sec-ops-012',
        text: 'What is the primary disadvantage of running an IPS in inline mode?',
        options: [
            'Higher power consumption',
            'Increased false positives',
            'Limited detection capability',
            'Potential network latency'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Inline mode can introduce network latency as all traffic must pass through the IPS for inspection before continuing to its destination.'
    },
    {
        id: 'sec-ops-013',
        text: 'During digital forensics investigation, which data should be collected first?',
        options: [
            'Configuration files',
            'RAM and temporary files',
            'Log files',
            'Hard drive images'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'RAM and temporary files are highly volatile and will be lost when the system powers down, making them the highest priority for collection in digital forensics.'
    },
    {
        id: 'sec-ops-014',
        text: 'What metric should a Security Director primarily use to effectively prioritize vulnerability remediation across the enterprise environment?',
        options: [
            'Age of the vulnerability',
            'Ease of exploitation',
            'Common Vulnerability Scoring System (CVSS)',
            'Number of affected systems'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'CVSS provides a standardized framework for assessing vulnerability severity based on multiple factors including impact, exploitability, and temporal metrics. This makes it the most comprehensive and objective method for prioritizing vulnerability patching.'
    },
    {
        id: 'sec-ops-015',
        text: 'When using an LDAP browser tool with secure connections, what is the most effective solution for resolving certificate errors?',
        options: [
            'Use a different LDAP browser',
            'Switch to non-secure LDAP',
            'Disable SSL/TLS verification',
            'Import the server certificate into the local trust store'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: "Installing the server certificate in the local trust store properly establishes the chain of trust, allowing secure LDAP connections while maintaining security. Other options either compromise security or don't address the root cause."
    },
    {
        id: 'sec-ops-016',
        text: 'After a recent ransomware attack, an administrator reviewed system log files. What type of security control does this represent?',
        options: [
            'Detective',
            'Preventive',
            'Corrective',
            'Compensating'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'Log review is a detective control as it helps identify and investigate security incidents after they occur, but does not prevent them.'
    },
    {
        id: 'sec-ops-017',
        text: 'A company is planning to establish a SIEM system for weekly log reviews by an analyst. What type of control is being implemented?',
        options: [
            'Corrective',
            'Preventive',
            'Deterrent',
            'Detective'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'SIEM systems and log reviews are detective controls as they help identify security events after they occur.'
    },
    {
        id: 'sec-ops-018',
        text: 'After receiving notification about potentially invalidated certificates, which method should be used to verify if company certificates require renewal?',
        options: [
            'CRL',
            'OCSP',
            'PKI validation',
            'Certificate pinning'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: 'OCSP provides real-time certificate validation status, unlike CRL which is only updated whenever a certificate is revoked. Public Key Infrastructure (PKI) is a framework where certificates are used to digitally sign and encrypt data. Certificate pinning is a security mechanism that allows a server to "pin" its public key certificate to a specific set of trusted sources, preventing attackers from using fraudulent certificates to impersonate the server.'
    },
    {
        id: 'sec-ops-019',
        text: 'To ensure software integrity in production, which security measure should be implemented?',
        options: [
            'Encryption',
            'Code signing',
            'Hash verification',
            'Digital watermarking'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Code signing provides both integrity verification and authenticity of software binaries.'
    },
    {
        id: 'sec-ops-020',
        text: "A security analyst suspects that a network device is transmitting authentication credentials in an unencrypted format. Which tool would be most effective in verifying this?",
        options: [
            "Nmap",
            "Netcat",
            "Tcpdump",
            "Wireshark"
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: "Wireshark is a network protocol analyzer that can capture and inspect network traffic, revealing any cleartext credentials being transmitted. Nmap is a network scanner, Netcat is a command-line utility for network connections, and Tcpdump is a command-line packet analyzer; while they can capture traffic, Wireshark's GUI and filtering capabilities make it best for this purpose."
    },
    // Q 21 removed
    {
        id: 'sec-ops-022',
        text: "Which of the following strategies is most effective in minimizing unauthorized login attempts?",
        options: [
            "Disabling all user accounts.",
            "Implementing multi-factor authentication (MFA).",
            "Removing all network firewalls.",
            "Regularly changing server IP addresses."
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: "Multi-factor authentication requires users to provide multiple forms of verification, making unauthorized access significantly harder. Disabling accounts prevents all access, legitimate or not. Removing firewalls exposes the network to numerous threats. Changing IP addresses offers minimal security as attackers can easily scan for new addresses."
    },
    {
        id: 'sec-ops-023',
        text: "What is the role of a Command-and-Control (C2) server in a cyberattack?",
        options: [
            "To provide instructions and receive data from compromised systems.",
            "To prevent unauthorized access to network resources.",
            "To encrypt sensitive data at rest and in transit.",
            "To detect and block malicious network traffic."
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: "C2 servers are used by attackers to control malware-infected machines, sending commands and receiving stolen data. Firewalls prevent unauthorized access. Encryption protects data confidentiality. Intrusion detection/prevention systems handle malicious traffic."
    },
    {
        id: 'sec-ops-024',
        text: "A compromised system is communicating with an external IP address on a non-standard port. This activity is a strong indicator of:",
        options: [
            "Normal network traffic.",
            "A successful Denial-of-Service (DoS) attack.",
            "Command-and-Control (C2) communication.",
            "A routine system update."
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.9,
        explanation: "Communication with an external IP on a non-standard port is a hallmark of C2 traffic, indicating a compromised system receiving instructions. Normal traffic uses standard ports and known destinations. DoS attacks disrupt service availability. System updates usually involve known servers and ports."
    },
    {
        id: 'sec-ops-025',
        text: "Malware has established a persistent connection to an external server. This connection is most likely used for:",
        options: [
            "Command and Control operations.",
            "Network monitoring and logging.",
            "Initiating a DDOS attack.",
            "Digital forensics."
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: "Persistent connections to external servers by malware are typically for C2, allowing attackers to maintain control and exfiltrate data."
    },
    {
        id: 'sec-ops-026',
        text: "What information can DHCP logs provide to security analysts during an incident investigation?",
        options: [
            "User login credentials and passwords.",
            "The mapping of IP addresses to MAC addresses and timestamps of assignments.",
            "Encrypted network traffic content.",
            "File system access permissions and changes."
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: "DHCP logs record IP address assignments, including the associated MAC addresses and the time of the lease. This information is crucial for tracking down devices involved in security incidents. DHCP logs do not store user credentials, encrypted traffic, or file system permissions."
    },
    {
        id: 'sec-ops-027',
        text: "During a network intrusion investigation, which log source would be MOST valuable in correlating a compromised system's MAC address to a dynamically assigned IP address at a specific point in time?",
        options: [
            "Firewall logs",
            "Intrusion Detection System (IDS) logs",
            "DHCP server logs",
            "DNS server logs"
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: "DHCP server logs maintain a record of IP address leases, associating MAC addresses with assigned IPs and timestamps, crucial for tracing compromised systems. Firewall logs record network traffic but not the DHCP lease information. IDS logs detect malicious activity. DNS logs resolve domain names to IPs."
    },
    {
        id: 'sec-ops-028',
        text: 'Following a security incident where compromised servers have been isolated from the network, what step should be prioritized next in the incident response lifecycle?',
        options: [
            'Remove all traces of malware and compromised components',
            'Document lessons learned and update procedures',
            'Restore systems to normal operation',
            'Gather additional forensic evidence'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'After containment, the next critical step is eradication - completely removing all traces of the compromise including malware, backdoors, and compromised accounts. This ensures the threat is fully eliminated before moving to system recovery.'
    },
    {
        id: 'sec-ops-029',
        text: 'A security analyst notices unusual internal network traffic attempting to reach protected data center systems. Which network security control would be most effective in preventing this unauthorized access?',
        options: [
            'Security Information and Event Management (SIEM)',
            'Virtual Private Network (VPN)',
            'Intrusion Prevention System (IPS)',
            'Access Control Lists (ACLs)'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'ACLs are the most appropriate tool for controlling internal network traffic flows between segments. They allow precise control over which systems can communicate with data center resources based on IP addresses and ports.'
    },
    {
        id: 'sec-ops-030',
        text: 'An organization located in Tornado Alley needs to ensure business operations can resume quickly after a major storm. Which component is most critical for service restoration?',
        options: [
            'Change management process',
            'Disaster recovery plan',
            'Data retention policy',
            'Stakeholder communication plan'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'A comprehensive disaster recovery plan is essential for quickly restoring critical business services after a natural disaster. It provides detailed procedures for system recovery, infrastructure repairs, and business process resumption.'
    },
    {
        id: 'sec-ops-031',
        text: 'A manufacturing company\'s IT team has just finished blocking a compromised IoT device that was behaving suspiciously. The SOC manager is debating the next steps. In addressing the broader security incident, which phase requires immediate attention?',
        options: [
            'Begin employee security awareness training',
            'Conduct a comprehensive sweep and cleanup of affected systems',
            'Update the incident response playbook',
            'Schedule a lessons learned meeting'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'After isolating a threat (containment), the critical next phase is eradication - performing a thorough cleanup of all affected systems to remove any lingering threats, backdoors, or compromised components before proceeding with recovery efforts.'
    },
    {
        id: 'sec-ops-032',
        text: 'During a routine security audit at a healthcare facility, the IT team discovers developers accessing patient records on test servers from their development environment. What is the most targeted solution to enforce proper network boundaries?',
        options: [
            'Deploy additional firewalls',
            'Implement database encryption',
            'Configure granular access control lists',
            'Install an IDS solution'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'While multiple security controls could help, ACLs provide the most precise and efficient method to control specific traffic flows between network segments, allowing administrators to explicitly define which development systems can access which resources.'
    },
    {
        id: 'sec-ops-033',
        text: 'Silicon Valley Bank\'s backup data center is located in an area prone to earthquakes. After a recent seismic event, which document is most crucial for maintaining operational continuity?',
        options: [
            'Asset inventory list',
            'Incident response plan',
            'Network topology map',
            'Disaster recovery procedures'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'While all documentation is valuable, a comprehensive disaster recovery plan is essential as it provides step-by-step procedures for restoring critical services, maintaining business operations, and recovering from natural disasters with minimal disruption.'
    },
    {
        id: 'sec-ops-034',
        text: 'During an IT infrastructure upgrade, what MTBF value would indicate the most reliable choice for new wireless access points?',
        options: [
            '50,000 hours',
            '75,000 hours',
            '100,000 hours',
            '25,000 hours'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'Mean Time Between Failures (MTBF) measures expected device reliability - higher values indicate better reliability. 100,000 hours (about 11.4 years) represents enterprise-grade hardware with excellent durability.'
    },
    {
        id: 'sec-ops-035',
        text: 'Scenario: A hospital\'s security team receives this alert:<br>[CRITICAL] 03:15 - Multiple failed SSH attempts from internal IP 192.168.45.12 to data center servers<br>[CRITICAL] 03:17 - Successful connection established to server DC-SQL-01<br>What immediate action is required?',
        options: [
            'Update firewall rules',
            'Isolate the compromised system',
            'Run malware scans',
            'Review access logs'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'When there\'s evidence of successful unauthorized access, immediate isolation of the compromised system is critical to prevent lateral movement and further compromise of the network.'
    },
    {
        id: 'sec-ops-036',
        text: 'ALERT: Shipping department computer shows:<br>08:15 - malware.exe detected, quarantine failed<br>08:16 - system32.dll modified<br>08:17 - network connections hidden<br>What\'s the likely infection?',
        options: [
            'Spyware',
            'Trojan',
            'Rootkit',
            'Worm'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'The combination of system file modifications and hidden network connections are classic rootkit behaviors, which attempt to conceal malicious activity by modifying core system functionality.'
    },
    {
        id: 'sec-ops-037',
        text: 'You need to examine:<br>- File creation timestamp<br>- Original author<br>- Application version<br>Which source provides this data?',
        options: [
            'System logs',
            'Registry entries',
            'Event viewer',
            'File metadata'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.1,
        explanation: 'File metadata contains embedded information about a file\'s creation, modification, and attributes including timestamps, author information, and version details.'
    },
    {
        id: 'sec-ops-038',
        text: 'Your threat intelligence platform shows multiple servers in Europe attempting repeated connections to your data center every 3 minutes. What security control would most effectively block this automated reconnaissance?',
        options: [
            'Virtual Private Network',
            'Access Control Lists',
            'Intrusion Prevention System',
            'Security Event Manager'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.65,
        explanation: 'An IPS can identify and block pattern-based attack attempts in real-time, making it ideal for stopping automated reconnaissance attempts through signature and behavior-based detection.'
    },
    {
        id: 'sec-ops-039',
        text: 'Your IPS detects exploit attempts against public web servers. System logs show unusual entries and potential compromise. What immediate response action is required?',
        options: [
            'Network isolation',
            'System shutdown',
            'Anti-malware scan',
            'User notification'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'When logs indicate compromise, immediate isolation of affected systems is critical to prevent lateral movement and contain the incident before further analysis and remediation.'
    },
    {
        id: 'sec-ops-040',
        text: 'A security team is implementing automated testing of their custom application. Which testing methodology involves automatically generating and submitting unexpected or malformed input data to identify potential vulnerabilities?',
        options: [
            'Regression testing',
            'Continous integration',
            'Integration testing',
            'Fuzz testing'
        ],
        correctAnswer: 3,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'Fuzz testing is an automated software testing technique that involves providing invalid, unexpected, or random data as inputs to a computer program. The program is then monitored for crashes, memory leaks, failed assertions, or potential vulnerabilities.'
    },
    {
        id: 'sec-ops-041',
        text: 'During off-hours, an edge router repeatedly crashes and reboots. Which type of attack is most likely occurring?',
        options: [
            'Buffer overflow',
            'SQL injection',
            'DDoS attack',
            'ARP poisoning'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Repeated crashing and reloading of an edge router during off-hours is typically indicative of a Distributed Denial of Service (DDoS) attack, where the router is overwhelmed with malicious traffic causing it to fail and restart.'
    },
    {
        id: 'sec-ops-042',
        text: 'A Managed Security Service Provider (MSSP) requests access to centralized event information from network devices. Which type of file would most likely be shared?',
        options: [
            'Syslog file',
            'Configuration backup',
            'Route table',
            'Access control list'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'Syslog files contain centralized logging information from network devices and are commonly shared with MSSPs for security monitoring and analysis purposes.'
    },
    {
        id: 'sec-ops-043',
        text: 'SOC analysts encounter an unknown alert pattern. Which response best follows incident handling procedures?',
        options: [
            'Reference existing playbooks for initial triage steps',
            'Create new response procedures immediately',
            'Escalate to senior management first',
            'Isolate affected systems automatically'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'When facing unknown alerts, analysts should first use existing playbooks to establish a baseline response and eliminate common issues, while gathering information for proper analysis. Creating new procedures without investigation or automatic isolation could cause unnecessary disruption.'
    },
    {
        id: 'sec-ops-044',
        text: 'Which command-line tool best helps identify established TCP connections and listening ports to verify legitimate network traffic?',
        options: [
            'netstat',
            'tracert',
            'nslookup',
            'route'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'While all these tools analyze network information, netstat specifically shows active TCP connections, listening ports, and related statistics needed to verify legitimate traffic patterns. Other tools focus on different aspects like path tracing or DNS resolution.'
    },
    {
        id: 'sec-ops-045',
        text: 'During a security assessment, a team discovers 47 critical vulnerabilities but cannot verify if they are exploitable. What type of assessment was likely performed?',
        options: [
            'Penetration test',
            'Vulnerability assessment',
            'Security audit',
            'Code review'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.8,
        explanation: 'A vulnerability assessment identifies potential vulnerabilities without actively exploiting them, while a penetration test would attempt exploitation to verify vulnerabilities. The high number of unverified findings indicates this was a vulnerability assessment, as a penetration test would focus on proving exploitation.'
    },
    {
        id: 'sec-ops-046',
        text: 'Which network security tool is specifically designed for real-time traffic analysis and packet logging to detect and prevent malicious activity?',
        options: [
            'Snort',
            'Wireshark',
            'Nmap',
            'tcpdump'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Snort is an open-source Network Intrusion Detection System (NIDS) that performs real-time traffic analysis and packet logging. While Wireshark is for packet analysis, Nmap for network mapping, and tcpdump for packet capture, Snort specifically focuses on detecting and preventing malicious activity through real-time analysis and rule-based detection.'
    },
    {
        "id": "sec-ops-047",
        "text": "A security analyst needs to perform detailed analysis of network traffic patterns and protocol behaviors. Which tool would be most appropriate for this task?",
        "options": [
            "Wireshark",
            "Nmap",
            "Netstat",
            "Ping"
        ],
        "correctAnswer": 0,
        "domain": "Security Operations",
        "difficulty": 0.5,
        "explanation": "Wireshark is the correct answer as it's a network protocol analyzer for detailed packet inspection. Nmap is a network scanner for host/service discovery, not traffic analysis. Netstat displays network connections and statistics, but lacks Wireshark's granular packet analysis. Ping tests basic network connectivity, not detailed analysis."
    },
    {
        "id": "sec-ops-048",
        "text": "Which network security tool is best suited for discovering active hosts, open ports, and services running on a network?",
        "options": [
            "Nmap",
            "Tcpdump",
            "Wireshark",
            "Snort"
        ],
        "correctAnswer": 0,
        "domain": "Security Operations",
        "difficulty": 0.5,
        "explanation": "Nmap is the correct answer as it's designed for network discovery, identifying active hosts, open ports, and services. Tcpdump captures network traffic but doesn't actively scan for hosts or services. Wireshark analyzes captured traffic, not network discovery. Snort is an intrusion detection/prevention system, not a network scanner."
    },
    {
        id: 'sec-ops-049',
        text: 'In network security, which attack involves creating fraudulent DNS records to redirect users to malicious websites?',
        options: [
            'ARP poisoning',
            'DNS spoofing',
            'MAC flooding',
            'VLAN hopping'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'DNS spoofing (also known as DNS cache poisoning) involves corrupting DNS resolver cache to return incorrect IP addresses, redirecting users to fraudulent websites. This can lead to phishing attacks and data theft.'
    },
    // q50 removed
    {
        id: 'sec-ops-051',
        text: 'During incident response, an analyst needs to analyze network traffic patterns. Which widely-used packet analyzer tool would be most appropriate?',
        options: [
            'Nmap',
            'Netstat',
            'Wireshark',
            'tcpdump'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'Wireshark is a comprehensive network protocol analyzer that allows detailed packet inspection and analysis, making it ideal for investigating network traffic patterns and potential security incidents.'
    },
    {
        id: 'sec-ops-052',
        text: 'An analyst observes unusual ARP responses on the network. Which attack technique might be in progress?',
        options: [
            'DNS cache poisoning',
            'ARP spoofing',
            'MAC flooding',
            'DHCP starvation'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'ARP spoofing (also known as ARP poisoning) involves sending falsified ARP messages to associate an attacker\'s MAC address with the IP address of a legitimate network resource, enabling man-in-the-middle attacks.'
    },
    {
        id: 'sec-ops-053',
        text: 'Which network security system, maintained by Cisco, provides real-time threat intelligence and reputation data?',
        options: [
            'VirusTotal',
            'AlienVault',
            'Talos',
            'ThreatConnect'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'Cisco Talos is a threat intelligence organization that provides real-time threat data, reputation scoring, and security research to protect networks against emerging threats.'
    },
    {
        id: 'sec-ops-054',
        text: 'Which metric represents the speed at which an organization can restore service after an incident?',
        options: [
            'RPO',
            'MTTR',
            'MTTF',
            'Inspection Rate'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'Mean Time to Restore/Recovery (MTTR) measures the average time required to restore a system to operational status after a failure or incident occurs.'
    },
    {
        id: 'sec-ops-055',
        text: 'What network issue occurs when multiple switches continuously forward broadcast frames, potentially causing network saturation?',
        options: [
            'Late collisions',
            'Broadcast storms',
            'ARP flooding',
            'MAC flapping'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'Broadcast storms occur when broadcast frames are repeatedly forwarded between switches in a loop, potentially overwhelming network resources and degrading performance. This is commonly prevented using Spanning Tree Protocol (STP).'
    },
    {
        id: 'sec-ops-056',
        text: 'A network administrator notices increased frame errors on a link. Which network issue typically causes frames to be interrupted during transmission?',
        options: [
            'Late collisions',
            'Broadcast storms',
            'Frame padding',
            'CRC errors'
        ],
        correctAnswer: 0,
        domain: 'Security Operations',
        difficulty: 0.7,
        explanation: 'Late collisions occur when two devices transmit simultaneously outside the normal collision window, often indicating duplex mismatches or cables exceeding maximum length specifications.'
    },
    {
        id: 'sec-ops-057',
        text: 'During a penetration test, an attacker captures and repeatedly sends legitimate authentication packets to a server. Which type of man-in-the-middle attack is being demonstrated?',
        options: [
            'Session hijacking',
            'Replay attack',
            'Pass-the-hash',
            'Cookie manipulation'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.6,
        explanation: 'A replay attack is a form of man-in-the-middle attack where valid data transmission is maliciously repeated or delayed. In this case, captured authentication packets are replayed to impersonate a legitimate user.'
    },

    {
        id: 'sec-ops-058',
        text: 'A security incident involves thousands of compromised IoT devices flooding a server. This differs from a traditional DoS attack because:',
        options: [
            'It uses multiple attack vectors',
            'It targets multiple victims',
            'It originates from distributed sources',
            'It only affects network resources'
        ],
        correctAnswer: 2,
        domain: 'Security Operations',
        difficulty: 0.5,
        explanation: 'A DDoS attack differs from a DoS attack primarily because it originates from multiple distributed sources (like compromised IoT devices) rather than a single source, making it harder to mitigate.'
    },
];